import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ENVIRONMENT } from '@ld.consumer-portal/models';

@Component({
  selector: 'ld-no-funded-loans-card',
  templateUrl: './no-funded-loans-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoFundedLoansCardComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly env = inject(ENVIRONMENT);

  protected readonly message = this.transloco.translate('noFundedLoansMessage', {
    servicingPhone: this.env.appSettings.servicingCustomerCare?.phone.link,
    servicingDisplay: this.env.appSettings.servicingCustomerCare?.phone.display,
    originationPhone: this.env.appSettings.applicationCustomerCare?.phone.link,
    originationDisplay: this.env.appSettings.applicationCustomerCare?.phone.display,
  });
}
